exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes Dialog_fadeIn__3Zmw3 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes Dialog_fadeIn__3Zmw3 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes Dialog_fadeOut__3RWmO {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes Dialog_fadeOut__3RWmO {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.Dialog_dialog__9I0v8 .Dialog_content__2R1nV {\n  position: relative; }\n\n.Dialog_busy__xux_o {\n  display: -webkit-flex;\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n  .Dialog_busy__xux_o > * {\n    margin-top: auto;\n    width: 100%; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"dialog": "Dialog_dialog__9I0v8",
	"content": "Dialog_content__2R1nV",
	"busy": "Dialog_busy__xux_o",
	"fadeIn": "Dialog_fadeIn__3Zmw3",
	"fadeOut": "Dialog_fadeOut__3RWmO"
};